import React from "react";
import styled from "styled-components";
import TastingNote from "../common/TastingNote";

interface TasteProgressBarProps {
    label: string;
    value: number;
    onChange?: (value: number) => void;
}

const TasteProgressBar: React.FC<TasteProgressBarProps> = ({ label, value, onChange }) => {
    const handleChange = (newValue: number) => {
        if (onChange) {
            // 값이 0-5 범위를 벗어나지 않도록 보장
            const clampedValue = Math.max(0, Math.min(5, newValue));
            onChange(clampedValue);
        }
    };

    // 값이 0-5 범위를 벗어나지 않도록 보장
    const clampedValue = Math.max(0, Math.min(5, value));

    return (
        <Container>
            <TastingNote label={label} value={clampedValue} readOnly={false} onChange={handleChange} />
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
`;

export default TasteProgressBar;
